import { XtreamContent } from '../api/xtreamAPI';

export function buildHomeChannelList(
  channels: XtreamContent[],
  favoriteIds: Set<string>,
  watchedAtByStreamId: Map<string, number>,
) {
  const favorites = channels.filter((channel) => favoriteIds.has(String(channel.stream_id || '')))
    .sort((left, right) =>
      (watchedAtByStreamId.get(String(right.stream_id || '')) || 0) -
      (watchedAtByStreamId.get(String(left.stream_id || '')) || 0)
    );
  const recent = channels.filter((channel) => watchedAtByStreamId.has(String(channel.stream_id || '')))
    .sort((left, right) =>
      (watchedAtByStreamId.get(String(right.stream_id || '')) || 0) -
      (watchedAtByStreamId.get(String(left.stream_id || '')) || 0)
    )
    .slice(0, 30);

  if (!favorites.length && !recent.length) {
    return { channels, favoriteCount: 0 };
  }
  return { channels: [...favorites, ...recent], favoriteCount: favorites.length };
}
